import { render } from "./SedeModal.vue?vue&type=template&id=1cadadfc"
import script from "./SedeModal.vue?vue&type=script&lang=js"
export * from "./SedeModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__